import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { Container, Button, Col, Row } from 'react-bootstrap';
import Slider from "react-slick";
import CountUp from 'react-countup';
import VisibilitySensor from "react-visibility-sensor";
import { LazyLoadImage } from 'react-lazy-load-image-component';

function DhruvKapoor() {
    window.scrollTo(0, 0);
    const [focus, setFocus] = React.useState(false);
    return (
        <div>
            <Helmet>

                <title>Unlocking Global Potential: 382% Surge in International Orders for Dhruv Kapoor</title>
                <meta name="description" content="" />
                <link rel="canonical" href="https://anbluxury.com/case-studies/adani-realty-case-study.html" />

            </Helmet>
            {/* first fold */}
            <div className="casestudy">
                <div className="box padmmdt padmmdb">

                    <Container>

                        <p className="text-left p1 pdl10"> <span class="spcase">DHRUV</span> KAPOOR</p>
                    </Container>

                    <Container fluid className="padbsmt padbsmb">
                        <Row>
                            <Col lg="2"></Col>
                            <Col lg="8">
                                <div className="circleboxfirst  padssmb">
                                    <img src={`${process.env.PUBLIC_URL}/img/bgbox.png`} className="roundbx" width="30%" alt="" />

                                    <div className="boxcentered tpfold">
                                        <h4 className="d-none d-sm-block cuspn"> <span class=""> Unlocking Global Potential: </span><br />  382% Surge in International Orders <br /> for Dhruv Kapoor  <br /></h4>
                                        <h4 className="d-block d-sm-none"> <span class="cuspn"> Unlocking Global Potential: </span>  <br />  382% Surge in International Orders <br /> for Dhruv Kapoor  <br /></h4>

                                    </div>
                                </div>
                            </Col>
                            <Col lg="2"></Col>
                        </Row>
                    </Container>
                </div>
            </div>
            {/* The brand fold */}
            <div className="lgbox  problem">

                <Container fluid className="tpfold pdr0 mbpdr15">
                    <Row>
                        <Col lg="10" md="12" sm="12" xs="12" className="padmmdt mbpt0 casebox offset-lg-1 ">
                            <p className="text-left p1 mrg30 " > <span class="spcase">THE</span> <strong>BRAND</strong>  </p>
                            <p className="marbmdt mbt20 ">
                                Dhruv Kapoor is an luxury brand founded in 2013, known for its gender-fluid designs that blend traditional Indian craftsmanship with modern, global fashion.
                            </p>
                            <p className="">
                                The brand incorporates bold prints, spiritual influences, and sustainable materials. With a strong presence in international markets and recognition from major fashion events such as Milan Fashion Week, Dhruv Kapoor has become a prominent name in luxury, advanced-contemporary fashion., combining Indian heritage with futuristic elements.
                            </p>
                        </Col>

                        <Col lg={{ span: 10 }} sm={{ span: 12 }} xs={{ span: 12 }} className="offset-lg-1 mbpdr15">
                            <br></br>
                            <LazyLoadImage effect="blur" src={`${process.env.PUBLIC_URL}/img/casestudy/dhruv/dhruv-kapoor-brand.avif`} width="100%" height="100%" className="img-fluid text-right" />
                            <br></br>
                            <br></br>
                            <br></br>

                        </Col>

                        <Col lg="10" md="12" sm="12" xs="12" className="mbpt0 casebox offset-lg-1 ">
                            <p className="mbt20 ">
                                <strong>Objectives:</strong>
                            </p>

                            <ul style={{ listStyle: 'initial' }}>
                                <li>Strengthen brand visibility and elevate positioning in the market.</li>
                                <li>Drive consistent revenue growth and increase revenue by reaching a wider audience, independent of promotional periods.</li>
                                <li>Expand into new international markets to boost global presence.</li>
                                <li>Launch Kapoor 2.0 (K2), a subsidiary focused on a more accessible, lower AOV offering.</li>
                            </ul>


                            <br></br>
                            <br></br>
                            <br></br>

                        </Col>


                    </Row>
                </Container>
            </div>
            {/* The opportunity */}


            <div className="box  problem padbxsb ">

                <Container fluid className="tpfold">
                    <Row>
                        <Col lg="8" md="10" sm="10" xs="12" className="padmmdt mbpt0 casebox offset-lg-1 ">
                            <p className="text-left p1 mrg30 " style={{ marginBottom: '50px' }}> <span class="spcase">THE</span> <strong>Problem</strong> </p>
                            <p className="">1. <strong>Stagnant revenue, no scale -</strong> With no significant increase outside of sale period, heavily reliant on stockists and multi-designer stores.  The website experienced higher revenue during seasonal sales, but showed no consistent growth.</p>
                            <img effect="blur" style={{ marginTop: 10, marginBottom: 20 }} src={`${process.env.PUBLIC_URL}/img/casestudy/dhruv/dhruv-kapoor-problem-chart.avif`} width="100%" height="100%" className="img-fluid text-right" />
                            <p className="">2. <strong>Low International Website Revenue -</strong> Despite the brand's global recognition through Milan Design Week and its presence in 30 countries via stockists, international traction on their own website remained minimal, with negligible revenue from international visitors.</p>
                            <p className="">3. <strong>Manual work -</strong> All business processes were manual, with no automation in place. Inventory and order fulfillment were handled manually, leading to delays, errors, and overall customer dissatisfaction.</p>
                        </Col>
                    </Row>
                </Container>
            </div>


            {/* Process */}
            <div className="lgbox  problem padbxsb">

                <Container fluid className="tpfold ">

                    <Row>
                        <Col lg="9" md="10" sm="10" xs="12" className="padmmdt mbpt0 casebox offset-lg-1 ">
                            <p className="text-left p1 mrg30 " style={{ marginBottom: '50px' }}> <span class="spcase">THE</span> <strong>Solution</strong> </p>
                            <p className="mbt20 ">
                                <strong>1. Refining Targeting for Scalable Growth:</strong>
                            </p>

                            <ul style={{ listStyleType: 'lower-alpha' }}>
                                <li style={{ marginBottom: 8 }}>Dhruv Kapoor’s <strong>high-AOV collections,</strong> ranging from <strong>$360 to $3000,</strong> cater to the <strong>top 5%</strong> but previously they were reaching a broader, less relevant audience. By leveraging <strong>OSIDE luxury audience</strong> insights, we refined the targeting to focus on key factors like <strong>income, job profiles, location,</strong> and <strong>interests</strong>. This more targeted approach allowed us to connect with the right <strong>audience</strong>, driving better engagement and aligning perfectly with the brand's <strong>luxury positioning</strong>.</li>
                                <li style={{ marginBottom: 8 }}><strong>Personalized Purchase Support via WhatsApp:</strong> Recognizing the need for a more hands-on approach, we redirected customers to WhatsApp for personalized assistance throughout the purchase journey. This offered customers full access to services, multiple payment options, and helped reduce friction during the buying process.</li>
                                <li style={{ marginBottom: 8 }}><strong>Automating Cart Recovery to Capture Drop-Offs:</strong> With significant drop-offs during the checkout process, we identified the opportunity to recover lost sales. Automated WhatsApp messages were set up to re-engage customers who abandoned their carts, offering personalized follow-ups and assistance to guide them through the purchase process.</li>
                                <li style={{ marginBottom: 8 }}><strong>Leveraging Celebrity Endorsements:</strong> While many <strong>celebrities</strong> already wore Dhruv Kapoor’s designs, the audience wasn't aware of this <strong>aspirational</strong> connection. By showcasing these endorsements in our communications, we made the brand feel more aspirational to customers, boosting its desirability and connecting the audience to the brand’s <strong>elite</strong> status. Highlighting these celebrity associations created a stronger emotional appeal and aligned the brand with a premium lifestyle.</li>
                                <li style={{ marginBottom: 8 }}><strong>Capitalizing on COD Preference:</strong> (COD) is a significant preference in India, with <strong>60% of Indians</strong> opting for it, and <strong>30% of them</strong> being luxury buyers. Offering COD as a payment option will lead to an expected <strong>10-15% increase</strong> in sales. To manage this, we introduced <strong>automated WhatsApp confirmation</strong> for COD orders, an <strong>OTP verification</strong> process via email or phone to authenticate the transaction, and <strong>restrictions</strong>  on high-risk locations known for high RTO (Return to Origin) rates. Additionally, we incentivized <strong>prepaid orders</strong> to further reduce the incidence of RTO and encourage more secure transactions.</li>
                            </ul>


                            <p className="mbt20 ">
                                <strong>2. Targeted International Expansion:</strong>
                            </p>


                            <ul style={{ listStyleType: 'lower-alpha' }}>
                                <li style={{ marginBottom: 8 }}><strong>Identifying top 5 markets -</strong> With international traction being low, we focused on setting up international markets maintaining free global shipping, and distinguishing these markets from the Indian market. This strategy aimed to drive better engagement and revenue from global customers.</li>
                                <li style={{ marginBottom: 8 }}><strong>Website Redesign for International Optimization:</strong> The website wasn’t optimized for international visitors, so we revamped the UI/UX to improve the shopping experience, including features like country-specific currency options, faster load times, and a design that better suited global customers.</li>
                            </ul>

                            <p className="mbt20 ">
                                <strong>3. Automating Operations for Efficiency:</strong>
                                The brand’s processes were previously manual, leading to delays, errors, and customer dissatisfaction. We implemented automation tools for inventory management, order fulfillment, and customer communications. This streamlined workflow reduced human error, sped up order processing, and improved customer satisfaction, allowing the team to focus on strategic growth rather than operational tasks.
                            </p>
                            <p className="mbt20 ">
                                <strong>4. Launching Kapoor 2.0 -</strong>
                                Kapoor 2.0 offers a <strong>unique opportunity</strong> to tap into a broader market. The new line builds a compelling narrative that resonates with both <strong>existing customers</strong> and a <strong>younger, aspirational audience</strong>. By implementing <strong>optimized e-commerce features</strong> such as product add-ons, urgency prompts, and cart incentives, we aim to increase conversions and drive sales. Additionally, at this lower price point, <strong>gift-giving</strong> becomes a key driver, making Kapoor 2.0 products a popular choice for customers looking to gift high-quality fashion to friends and family.
                            </p>

                        </Col>
                    </Row>
                </Container>
            </div>
            {/* the impact */}
            <div className="lgbox  problem padbxsb">

                <Container fluid className="tpfold ">
                    <Row>
                        <Col lg="10" md="10" sm="10" xs="12" className="padmmdt mbpt0 casebox offset-lg-1 ">
                            <p className="text-left p1 mrg30 " > <span class="spcase">THE</span> <strong>IMPACT</strong> </p>
                        </Col>

                        <Row>
                            <Col lg="9" md="10" sm="10" xs="12" className="mbpt0 padssmt casebox offset-lg-1 ">
                                <img effect="blur" style={{ marginTop: 10, marginBottom: 20 }} src={`${process.env.PUBLIC_URL}/img/casestudy/dhruv/dhruv-kapoor-impact-chart.png`} width="100%" height="100%" className="img-fluid text-right" />
                            </Col>
                        </Row>
                        <Row>
                            <Col lg="10" md="10" sm="10" xs="12" className="mbpt0 casebox offset-lg-1 ">
                             <div id="iwantto" className="seomatters  bgb">
                                <Container className="padbmdt padbmdb">

                                    <h3 className="text-center txtcolor  padsmdb">Should you advertise <span>Luxury Retail stores</span> on Digital ?</h3>
                                    <Row className="padsmdb">
                                        <Col lg="4" md="4" sm="4">
                                            <div className="circleboxfirst  padssmb pdtb20">
                                                <img src={`${process.env.PUBLIC_URL}/img/bgbox.png`} className="servicescirbox" width="40%" alt="" />
                                                <div className="boxcentered">
                                                    <h1 className="d-none d-sm-block"><CountUp start={focus ? 0 : null} end={75} redraw={true}>
                                                        {({ countUpRef }) => (
                                                            <VisibilitySensor onChange={(isVisible) => {
                                                                if (isVisible) { setFocus(true); }
                                                            }}>
                                                                <span ref={countUpRef} />
                                                            </VisibilitySensor>
                                                        )}
                                                    </CountUp>% <br /><br /></h1>
                                                    <h1 className="d-block d-sm-none"> <CountUp start={focus ? 0 : null} end={75} redraw={true}>
                                                        {({ countUpRef }) => (
                                                            <VisibilitySensor onChange={(isVisible) => {
                                                                if (isVisible) { setFocus(true); }
                                                            }}>
                                                                <span ref={countUpRef} />
                                                            </VisibilitySensor>
                                                        )}
                                                    </CountUp>% </h1>

                                                </div>
                                            </div>
                                            <p>Consumers say that they have bought luxury brands that they discovered on Instagram.</p><br />
                                        </Col>
                                        <Col lg="4" md="4" sm="4">
                                            <div className="circleboxfirst  padssmb pdtb20">
                                                <img src={`${process.env.PUBLIC_URL}/img/bgbox.png`} className="servicescirbox" width="40%" alt="" />
                                                <div className="boxcentered">
                                                    <h1 className="d-none d-sm-block"><CountUp start={focus ? 0 : null} end={61} redraw={true}>
                                                        {({ countUpRef }) => (
                                                            <VisibilitySensor onChange={(isVisible) => {
                                                                if (isVisible) { setFocus(true); }
                                                            }}>
                                                                <span ref={countUpRef} />
                                                            </VisibilitySensor>
                                                        )}
                                                    </CountUp>% <br /><br /></h1>
                                                    <h1 className="d-block d-sm-none"><CountUp start={focus ? 0 : null} end={61} redraw={true}>
                                                        {({ countUpRef }) => (
                                                            <VisibilitySensor onChange={(isVisible) => {
                                                                if (isVisible) { setFocus(true); }
                                                            }}>
                                                                <span ref={countUpRef} />
                                                            </VisibilitySensor>
                                                        )}
                                                    </CountUp>% </h1>
                                                </div>
                                            </div>

                                            <p>Luxury consumers depend on local searches to check the store in advance they will be shopping in.</p><br />

                                        </Col>
                                        <Col lg="4" md="4" sm="4">
                                            <div className="circleboxfirst  padssmb pdtb20">
                                                <img src={`${process.env.PUBLIC_URL}/img/bgbox.png`} className="servicescirbox" width="40%" alt="" />
                                                <div className="boxcentered">
                                                    <h1 className="d-none d-sm-block"><CountUp start={focus ? 0 : null} end={90} redraw={true}>
                                                        {({ countUpRef }) => (
                                                            <VisibilitySensor onChange={(isVisible) => {
                                                                if (isVisible) { setFocus(true); }
                                                            }}>
                                                                <span ref={countUpRef} />
                                                            </VisibilitySensor>
                                                        )}
                                                    </CountUp>% <br /><br /></h1>
                                                    <h1 className="d-block d-sm-none"><CountUp start={focus ? 0 : null} end={90} redraw={true}>
                                                        {({ countUpRef }) => (
                                                            <VisibilitySensor onChange={(isVisible) => {
                                                                if (isVisible) { setFocus(true); }
                                                            }}>
                                                                <span ref={countUpRef} />
                                                            </VisibilitySensor>
                                                        )}
                                                    </CountUp>%</h1>
                                                </div>
                                            </div>

                                            <p>Luxury consumers want to know everything about a product on a website before they stepped in a store.</p><br />

                                        </Col>
                                    </Row>
                                   
                                </Container>
                            </div>
                                <h3 className="tcgold marbxst marbxsb">58% hike in revenue</h3>
                            </Col>
                        </Row>
                        <Row>
                            <Col lg="9" md="10" sm="10" xs="12" className="mbpt0 casebox offset-lg-1 ">
                                <h3 className="tcgold marbxst marbxsb">382% increase in international orders in 2025 after we started advertising</h3>
                            </Col>
                        </Row>
                        <Row>
                            <Col lg="9" md="10" sm="10" xs="12" className="mbpt0 casebox offset-lg-1 ">
                                <h3 className="tcgold marbxst marbxsb">Increased brand recognition worldwide</h3>
                            </Col>
                        </Row>
                    </Row>

                </Container>
            </div>

            <div className="lgbox build endbox">
                <Container fluid className="pdlr0">
                    <Row className="text-left  mglr0">

                        <Col lg="6" sm="6" xs="12">
                            <Link to={`${process.env.PUBLIC_URL}/case-studies/isaia-retail-store-digital-transformation.html`}>
                                <Row className="marssmt marssmb mglr0">

                                    <Col lg="3" sm="3" xs="3" >
                                        <LazyLoadImage effect="blur" src={`${process.env.PUBLIC_URL}/img/casestudy/footerlogo/isaia.png`} className="mx-auto img-fluid text-right" />
                                    </Col>
                                    <Col lg="5" sm="6" xs="7">

                                        <h4 className="tcgold">ISAIA </h4>
                                        <p>Store Footfalls increased by 100% in 4 months </p>
                                    </Col>
                                    <Col lg="2" sm="3" xs="2" className="marbxst">
                                        <img src={`${process.env.PUBLIC_URL}/img/righticon.png`} width="40%" className=" text-right" />
                                    </Col>
                                </Row>
                            </Link>
                        </Col>

                        <Col lg="6" sm="6" xs="12" className="bgbl " >
                            <Link to={`${process.env.PUBLIC_URL}/case-studies/ecommerce-conversion-rate-case-study.html`}>
                                <Row className="marssmt marssmb mglr0">
                                    <Col lg="3" sm="3" xs="3" >
                                        <LazyLoadImage effect="blur" src={`${process.env.PUBLIC_URL}/img/casestudy/footerlogo/saundh.png`} className="mx-auto img-fluid text-right" />
                                    </Col>
                                    <Col lg="5" sm="6" xs="7">

                                        <h4 className="tcgold">Saundh </h4>
                                        <p>5X Improvement in E-Commerce Conversion Rate.</p>
                                    </Col>
                                    <Col lg="2" sm="3" xs="2" className="marbxst">
                                        <img src={`${process.env.PUBLIC_URL}/img/righticon.png`} width="40%" className=" text-right" />
                                    </Col>
                                </Row>
                            </Link>
                        </Col>
                    </Row>
                </Container>
            </div>
        </div>

    )
}
export default DhruvKapoor;